import { render, staticRenderFns } from "./ServiceRentalItem.vue?vue&type=template&id=5a4ce44e&scoped=true"
import script from "./ServiceRentalItem.vue?vue&type=script&lang=js"
export * from "./ServiceRentalItem.vue?vue&type=script&lang=js"
import style0 from "./ServiceRentalItem.vue?vue&type=style&index=0&id=5a4ce44e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4ce44e",
  null
  
)

export default component.exports